import { render, staticRenderFns } from "./AppointmentsEmpy.vue?vue&type=template&id=3bc559a2&scoped=true"
import script from "./AppointmentsEmpy.vue?vue&type=script&lang=js"
export * from "./AppointmentsEmpy.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsEmpy.vue?vue&type=style&index=0&id=3bc559a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc559a2",
  null
  
)

export default component.exports